import { normalizeDataGridFilterExpression } from '@utils/gridFilterExpression';

const LOAD_OPTION_KEYS = [
    'skip',
    'take',
    'requireTotalCount',
    'requireGroupCount',
    'sort',
    'filter',
    'totalSummary',
    'group',
    'groupSummary',
    'select',
];

const isLoadOptionPresent = (options: any, key: string) =>
    key in options && options[key] !== undefined && options[key] !== null && options[key] !== '';

const getProcessedOptionValue = (options: any, key: string) => {
    let optionValue = options[key];
    if (key === 'filter') {
        const normalizedFilter = normalizeDataGridFilterExpression(options[key]);
        optionValue = Array.isArray(normalizedFilter) ? prepareFilter(normalizedFilter) : normalizedFilter;
    }
    return optionValue;
};

export const getLoadOptionsParameters = (options: any) => {
    let params: string[] = [];
    LOAD_OPTION_KEYS.forEach((i) => {
        if (isLoadOptionPresent(options, i)) {
            const optionValue = getProcessedOptionValue(options, i);
            params.push(`${encodeURIComponent(i)}=${encodeURIComponent(JSON.stringify(optionValue))}`);
        }
    });
    return params;
};

/**
 * Возвращает loadOptions в виде объекта со значениями-JSON-строками — для передачи в теле POST-запроса.
 * Значения формируются ровно как в query (getLoadOptionsParameters), но без encodeURIComponent:
 * те же ключи, та же обработка filter (normalize + escape спецсимволов) и тот же JSON.stringify.
 * Бэк кладёт эти пары в DataSourceLoadOptionsParser — тот же код, что разбирает query GET-версии.
 */
export const getLoadOptionsObject = (options: any): Record<string, string> => {
    const result: Record<string, string> = {};
    LOAD_OPTION_KEYS.forEach((i) => {
        if (isLoadOptionPresent(options, i)) {
            result[i] = JSON.stringify(getProcessedOptionValue(options, i));
        }
    });
    return result;
};

function prepareFilter(options: any)
{
    if (!Array.isArray(options))
        return options;

    const prepareValue = (value: any): any => {
        if (Array.isArray(value)) return value.map(prepareValue);
        if (value === undefined || value === null) return value;
        if (typeof value !== 'string') return value;
        return escapeSpecialChars(value);
    };

    const cloned = [...options];
    const isLeaf =
        cloned.length >= 3 &&
        !Array.isArray(cloned[0]) &&
        typeof cloned[1] === 'string';

    if (isLeaf) {
        // Лист может содержать несколько значений (например, between)
        for (let index = 2; index < cloned.length; index++) {
            cloned[index] = prepareValue(cloned[index]);
        }
        return cloned;
    }

    for (let index = 0; index < cloned.length; index++) {
        if (Array.isArray(cloned[index])) {
            cloned[index] = prepareFilter(cloned[index]);
        }
    }

    return cloned;
}

// Escapes XNika query syntax chars inside filter values.
function escapeSpecialChars(input: string) {
    if (input == null) return '';

    return input.replace(/[{}\/]/g, (match) => `\\${match}`);
}

export const getLoadOptionsQuery = (options: any, ampersandPrefix: boolean = false) => {
    let params: string[] = getLoadOptionsParameters(options);

    let query = '';

    if (params.length > 0) query = (ampersandPrefix ? '&' : '') + params.join('&');

    return query;
};
